import React, { PropTypes } from 'react';
import { FlatButton, MenuItem, TextField, SelectField, Toggle } from 'material-ui';
import TwoColumnRow from '../../../tc-ui/two-column-row';
import GenericDialog from './generic-dialog';
import { isNil, isEmpty, either, equals, contains, complement } from 'ramda';

const isNilOrEmpty = either(isNil, isEmpty);
const isNotNilOrEmpty = complement(isNilOrEmpty);

const storageLinkFields = [
  {
    leftLabel: 'Content Name',
    prop: 'name',
    hintText: 'eg. 2017 Brochure',
  },
  {
    leftLabel: 'Public URL',
    prop: 'url',
    hintText: 'https://drive.google.com/open?id=12345',
  },
  {
    leftLabel: 'Storage Provider',
    prop: 'storageProvider',
  },
];

const credentialFields = [
  {
    leftLabel: 'Username',
    prop: 'username',
  },
  {
    leftLabel: 'Password',
    prop: 'password',
  },
];

const StorageLink = props => {
  const {
    onCancel,
    clearState,
    state,
    submitFile,
    setState,
    generateErrorText,
    existingUrls,
  } = props;

  return (
    <GenericDialog
      dialogTitle="External Public Storage Link"
      actions={[
        <FlatButton
          label="Cancel"
          primary
          onTouchTap={() => {
            onCancel();
            clearState();
          }}
        />,
        <FlatButton
          label="Submit"
          secondary
          onTouchTap={() => submitFile()}
          disabled={contains(state.url, existingUrls) || isNilOrEmpty(state.url) || isNilOrEmpty(state.name) || isNilOrEmpty(state.storageProvider) || !contains('http', state.url)}
        />,
      ]}
      fieldsToMap={storageLinkFields}
      mainContent={
        <div>
          {
            storageLinkFields.map((linkField, index) => {
              return (
                <div key={index}>
                  <TwoColumnRow
                    leftColumnClassName="Grid"
                    leftColumnContent={
                      <div className="Grid-cell Grid-cell--center">
                        {linkField.leftLabel}
                      </div>
                    }
                    leftColumnStyle={{ width: '25%', height: '34px' }}
                    rightColumnStyle={{ width: '70%' }}
                    rightColumnContent={
                      <div>
                        {
                          equals(linkField.prop, 'storageProvider') ?
                            <SelectField
                              style={{ width: '100%', marginTop: '-10px', overflow: '-moz-scrollbars-none' }}
                              value={state.storageProvider}
                              onChange={(event, i, value) => setState({
                                storageProvider: value,
                              })}
                              hintText="Select where your files are stored"
                            >
                              <MenuItem value={'Dropbox'} primaryText="Dropbox"/>
                              <MenuItem value={'Google Drive'} primaryText="Google Drive"/>
                              <MenuItem value={'OneDrive'} primaryText="OneDrive"/>
                              <MenuItem value={'Box'} primaryText="Box"/>
                              <MenuItem value={'Other'} primaryText="Other (Enter Name Below)"/>
                            </SelectField> :
                            <div style={{ overflow: '-moz-scrollbars-none' }}>
                              <TextField
                                key={linkField.prop}
                                style={{ border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px' }}
                                inputStyle={{ fontSize: '14px', whiteSpace: 'pre-wrap', position: 'absolute', marginTop: '-40px', padding: '0 5px' }}
                                underlineShow={false}
                                onChange={({ target: { value } }) => setState({
                                  [linkField.prop]: value,
                                })}
                                value={state[linkField.prop]}
                                hintText={linkField.hintText}
                                hintStyle={{ margin: '15px 0 0 5px', position: 'relative', fontSize: '14px' }}
                              />
                              {
                                equals(linkField.prop, 'url') && isNotNilOrEmpty(state.url) && contains(state.url, existingUrls) ?
                                  generateErrorText('duplicateUrlError') : <span/>
                              }
                              {
                                equals(linkField.prop, 'url') && isNotNilOrEmpty(state.url) && !contains('http', state.url) ? generateErrorText('missingHttp') : <span/>
                              }
                            </div>
                        }
                      </div>
                    }
                  />
                </div>
              );
            })
          }
        </div>
      }
      subContent={
        <div>
          {
            equals(state.storageProvider, 'Other') ?
              <div style={{ verticalAlign: 'middle', marginTop: '-5px' }}>
                <TwoColumnRow
                  leftColumnClassName="Grid"
                  leftColumnStyle={{ width: '25%', height: '34px' }}
                  rightColumnStyle={{ width: '70%' }}
                  rightColumnContent={
                    <TextField
                      key="otherStorageProvider"
                      style={{ border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px' }}
                      inputStyle={{ fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' }}
                      underlineShow={false}
                      onChange={({ target: { value } }) => setState({
                        otherStorageProvider: value,
                      })}
                      value={state.otherStorageProvider}
                    />
                  }
                />
              </div> : <span/>
          }
          <div style={{ width: '35.5%' }}>
            <Toggle
              label="Requires Credentials"
              labelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
              elementStyle={{ border: '1px solid red' }}
              onToggle={() => setState({ showCredentialFields: !state.showCredentialFields })}
            />
          </div>
          {
            state.showCredentialFields ?
              <div style={{ marginTop: '35px' }}>
                {
                  credentialFields.map((linkField, index) => {
                    return (
                      <div key={index}>
                        <TwoColumnRow
                          leftColumnClassName="Grid"
                          leftColumnContent={
                            <div className="Grid-cell Grid-cell--center">
                              {linkField.leftLabel}
                            </div>
                          }
                          leftColumnStyle={{ width: '25%', height: '34px' }}
                          rightColumnStyle={{ width: '70%' }}
                          rightColumnContent={
                            <TextField
                              key={linkField.prop}
                              style={{ border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px' }}
                              inputStyle={{ fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' }}
                              underlineShow={false}
                              onChange={({ target: { value } }) => setState({
                                [linkField.prop]: value,
                              })}
                              value={state[linkField.prop]}
                            />
                          }
                        />
                      </div>
                    );
                  })
                }
              </div> : <span/>
          }
        </div>
      }
    />
  );
};

StorageLink.propTypes = {
  onCancel: PropTypes.func,
  clearState: PropTypes.func,
  state: PropTypes.object,
  submitFile: PropTypes.func,
  setState: PropTypes.func,
  generateErrorText: PropTypes.func,
  existingUrls: PropTypes.array,
};

export default StorageLink;



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/title-bar/external-links/storage-link.jsx